/**
 * Empty objects are returned as empty arrays from backend ¯\_(ツ)_/¯, so here is a
 * function that accepts either an object or an array as input
 * and returns either an object or null.
 *
 * @param {Object|Array} data - The input data, which can be either an object or an array.
 * @returns {Object|null} The processed data object, or null if the input was invalid.
 */

export function serializeObject(data) {
  return Array.isArray(data) ? null : data;
}
